import { render, staticRenderFns } from "./carMonthCardConfigList.vue?vue&type=template&id=6156dc3e&scoped=true"
import script from "./carMonthCardConfigList.vue?vue&type=script&lang=js"
export * from "./carMonthCardConfigList.vue?vue&type=script&lang=js"
import style0 from "./carMonthCardConfigList.vue?vue&type=style&index=0&id=6156dc3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6156dc3e",
  null
  
)

export default component.exports